import React from 'react';

export const GoogleLogoIcon = (props: JSX.IntrinsicElements['svg']) => (
    <svg
        width="50"
        height="50"
        viewBox="0 0 50 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <rect width="50" height="50" rx="3" fill="#fff" />
        <rect x="10.909" y="11.818" width="27.273" height="27.273" rx="2" fill="#fff" />
        <path
            d="M20.808 14.175a12.588 12.588 0 018.204.07 11.885 11.885 0 013.92 2.382c-.378.403-.79.783-1.185 1.172l-2.239 2.197a6.654 6.654 0 00-2.626-1.517c-2.566-.756-5.35-.045-7.213 1.842a7.366 7.366 0 00-1.767 2.817l-3.995-3.035c1.428-2.778 3.903-4.904 6.9-5.928z"
            fill="#EA4335"
        />
        <path
            d="M12.854 23.093a11.81 11.81 0 011.059-3.003l3.995 3.035a7.06 7.06 0 000 4.645 1215.44 1215.44 0 01-3.987 3.033 11.644 11.644 0 01-1.067-7.71z"
            fill="#FBBC05"
        />
        <path
            d="M24.79 23.214h11.458a13.875 13.875 0 01-.308 6.339 10.81 10.81 0 01-3.084 4.952l-3.871-2.958a5.61 5.61 0 002.436-3.677h-6.64c.009-1.551.009-3.103.009-4.656z"
            fill="#4285F4"
        />
        <path
            d="M13.907 30.811c1.328-1.007 2.657-2.019 3.987-3.035a7.434 7.434 0 002.79 3.664c.814.56 1.737.95 2.711 1.148.96.176 1.945.176 2.906 0a7.051 7.051 0 002.683-1.038l3.872 2.957a11.082 11.082 0 01-4.991 2.54c-2.052.473-4.19.451-6.231-.064a12.082 12.082 0 01-4.426-2.188 12.08 12.08 0 01-3.301-3.984z"
            fill="#34A853"
        />
    </svg>
);
